import { CurrencyRupeeSharp } from "@mui/icons-material";
import { Box, Grid, Skeleton } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AccordianContainer from "../../../CustomComponents/AccordianContainer";
import CustomButton from "../../../CustomComponents/CustomButton";
import CustomDataGrid from "../../../CustomComponents/CustomDataGrid";
import CustomTextField from "../../../CustomComponents/CustomTextField";
import { useSelector } from "react-redux";

const RepaymentStructure = (props) => {
  const [accordianOpen, setAccordianOpen] = useState(true);
  const [repaymentSchedule, setrepaymentSchedule] = useState({
    amortModelList: [],
  });

  const [repaymentScheduleLoading, setRepaymentScheduleLoading] =
    useState(true);

  //Selecting from store
  const filterValues = useSelector(
    (state) => state.repaymentStructureFilter.filterValues
  );

  let count = 1;

  useEffect(() => {
    // temp fix to retain scroll to top.
    setRepaymentScheduleLoading(true);
    window.scrollTo(0, 0);
    getRepaymentSchedule();
  }, [filterValues]);

  const getRepaymentSchedule = async () => {
    const response = await axios.post("/repayment/getEmiDataByAppNum", {
      applicationNum: filterValues.applicationValue,
      mode: "MODE",
    });
    setrepaymentSchedule(response.data);
    await axios
      .post(
        "/generateRepaySchedule",
        {
          applicationNum: filterValues.applicationValue,
        },
        { method: "POST", responseType: "blob" }
      )
      .then((response) => {
        setRepaymentScheduleLoading(false);
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `Repayment_Schedule-` + filterValues.applicationValue + `.pdf`
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
  };

  const BasicContent = (
    <>
      <Box component="form">
        <Grid container columnSpacing={2} rowSpacing={0}>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
              disabled={true}
              required={false}
              label="Applicant Name"
              id="customerName"
              variant="standard"
              value={repaymentSchedule.customerName}
              type="text"
              placeholder=""
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
              disabled={true}
              required={false}
              label="Loan Type"
              id="loanType"
              variant="standard"
              value={repaymentSchedule.loanType}
              type="text"
              placeholder=""
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
              disabled={true}
              required={false}
              label="Application Number"
              id="applicationNumber"
              variant="standard"
              value={repaymentSchedule.applicationNum}
              type="text"
              placeholder=""
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
              disabled={true}
              required={false}
              label="Sanctioned Loan Amount (₹)"
              id="sanctionAmt"
              variant="standard"
              value={parseInt(repaymentSchedule.sanctionAmount).toLocaleString(
                "en-IN"
              )}
              type="text"
              placeholder=""
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
              disabled={true}
              required={false}
              label="Tenure (In Months)"
              id="tenure"
              variant="standard"
              value={repaymentSchedule.tenure}
              type="text"
              placeholder=""
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
              disabled={true}
              required={false}
              label="Frequency"
              id="frequency"
              variant="standard"
              value={repaymentSchedule.frequency}
              type="text"
              placeholder=""
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
              disabled={true}
              required={false}
              label="Total Principal Paid (A)"
              id="principal"
              variant="standard"
              value={parseInt(
                repaymentSchedule.totalPrincipalAmount
              ).toLocaleString("en-IN")}
              type="text"
              placeholder=""
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
              disabled={true}
              required={false}
              label="Total Interest Paid (B)"
              id="interest"
              variant="standard"
              value={parseInt(repaymentSchedule.totalInterest).toLocaleString(
                "en-IN"
              )}
              type="text"
              placeholder=""
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
              disabled={true}
              required={false}
              label="Total Amount Paid (A+B)"
              id="amount"
              variant="standard"
              value={parseInt(
                repaymentSchedule.totalPrincipalAmount +
                  repaymentSchedule.totalInterest
              ).toLocaleString("en-IN")}
              type="text"
              placeholder=""
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
              disabled={true}
              required={false}
              label="Loan Period"
              id="loanPeriod"
              variant="standard"
              value={repaymentSchedule.loanPeriod}
              type="text"
              placeholder=""
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
              disabled={true}
              required={false}
              label="Billing Date"
              id="billingDate"
              variant="standard"
              value={new Date(repaymentSchedule.fbd).toLocaleDateString(
                "fr-FR"
              )}
              type="text"
              placeholder=""
            />
          </Grid>
        </Grid>
      </Box>
    </>
  );

  const scheduleColumns = [
    {
      field: "duePeriod",
      headerName: "Due Period",
      headerAlign: "center",
      type: "string",
      hideable: false,
      sortable: false,
      filterable: false,
      flex: 130,
      align: "left",
    },
    {
      field: "noOfDays",
      headerName: "No. Of Days",
      headerAlign: "center",
      type: "string",
      flex: 90,
      align: "right",
      editable: false,
      hideable: false,
      sortable: false,
      filterable: false,
    },
    {
      field: "openingAmt",
      headerAlign: "center",
      type: "string",
      flex: 160,
      align: "right",
      editable: false,
      hideable: false,
      sortable: false,
      filterable: false,
      renderHeader: (params) => {
        return (
          <>
            {"Opening Principal ("} <CurrencyRupeeSharp fontSize="small" />{" "}
            {")"}
          </>
        );
      },
      renderCell: (params) => {
        return parseInt(params.value).toLocaleString("en-IN");
      },
    },
    {
      field: "disbAmount",
      headerAlign: "center",
      type: "string",
      flex: 190,
      align: "right",
      editable: false,
      hideable: false,
      sortable: false,
      filterable: false,
      renderHeader: (params) => {
        return (
          <>
            {"Disbursement ("} <CurrencyRupeeSharp fontSize="small" /> {")"}
          </>
        );
      },
      renderCell: (params) => {
        return parseInt(params.value).toLocaleString("en-IN");
      },
    },
    {
      field: "installmentToPay",
      headerAlign: "center",
      type: "string",
      flex: 100,
      align: "right",
      editable: false,
      hideable: false,
      sortable: false,
      filterable: false,
      renderHeader: (params) => {
        return (
          <>
            {"Installment To Pay ("} <CurrencyRupeeSharp fontSize="small" />{" "}
            {")"}
          </>
        );
      },
      renderCell: (params) => {
        return parseInt(params.value).toLocaleString("en-IN");
      },
    },
    {
      field: "monthlyAmt",
      headerAlign: "center",
      type: "string",
      flex: 100,
      align: "right",
      editable: false,
      hideable: false,
      sortable: false,
      filterable: false,
      renderHeader: (params) => {
        return (
          <>
            {"EMI ("} <CurrencyRupeeSharp fontSize="small" /> {")"}
          </>
        );
      },
      renderCell: (params) => {
        return parseInt(params.value).toLocaleString("en-IN");
      },
    },
    {
      field: "principal",
      headerAlign: "center",
      type: "string",
      flex: 165,
      align: "right",
      editable: false,
      hideable: false,
      sortable: false,
      filterable: false,
      renderHeader: (params) => {
        return (
          <>
            {"Principal ("} <CurrencyRupeeSharp fontSize="small" /> {")"}
          </>
        );
      },
      renderCell: (params) => {
        return parseInt(params.value).toLocaleString("en-IN");
      },
    },
    {
      field: "interest",
      headerAlign: "center",
      type: "string",
      flex: 165,
      align: "right",
      editable: false,
      hideable: false,
      sortable: false,
      filterable: false,
      renderHeader: (params) => {
        return (
          <>
            {"Interest ("} <CurrencyRupeeSharp fontSize="small" /> {")"}
          </>
        );
      },
      renderCell: (params) => {
        return parseInt(params.value).toLocaleString("en-IN");
      },
    },
    {
      field: "repayAmt",
      headerAlign: "center",
      type: "string",
      flex: 165,
      align: "right",
      editable: false,
      hideable: false,
      sortable: false,
      filterable: false,
      renderHeader: (params) => {
        return (
          <>
            {"Prepayment ("} <CurrencyRupeeSharp fontSize="small" /> {")"}
          </>
        );
      },
      renderCell: (params) => {
        return parseInt(params.value).toLocaleString("en-IN");
      },
    },
    {
      field: "closingAmt",
      headerAlign: "center",
      type: "string",
      flex: 176,
      align: "right",
      editable: false,
      hideable: false,
      sortable: false,
      filterable: false,
      renderHeader: (params) => {
        return (
          <>
            {"Closing Principal ("} <CurrencyRupeeSharp fontSize="small" />{" "}
            {")"}
          </>
        );
      },
      renderCell: (params) => {
        return parseInt(params.value).toLocaleString("en-IN");
      },
    },
  ];
  return (
    <>
      {repaymentScheduleLoading && (
        <Box sx={{ backgroundColor: "white", minHeight: "320px" }}>
          <Skeleton
            variant="rounded"
            animation="wave"
            width="100%"
            height={
              window.innerHeight > 650 ? window.innerHeight / 1.8 : "260px"
            }
          />
        </Box>
      )}
      {!repaymentScheduleLoading && (
        <>
          <AccordianContainer
            title={"Repayment Schedule"}
            initialOpen={true}
            setAccordianOpen={setAccordianOpen}
          >
            <Box
              sx={{
                width: "100%",
                backgroundColor: "white",
                marginBottom: "16px",
                marginTop: "-2%",
              }}
            >
              {BasicContent}
            </Box>
          </AccordianContainer>
          <Box sx={{ width: "100%", alignContent: "center" }}>
            <CustomDataGrid
              noDataMessage="No Repayment Schedule."
              noDataOnFilterMessage="No Repayment Schedule on Applied Filter."
              rows={repaymentSchedule.amortModelList}
              columns={scheduleColumns}
              rowHeight={40}
              pageSize={12}
              pageSizeOptions={[12]}
              gridHeight={"585px"}
              getRowId={(row) => {
                return count++;
              }}
              gridLazyLoad={() => {}}
              onSortModelChange={() => {}}
            />
          </Box>
          {/* <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          margin: "8px 0px 8px 0px",
        }}
      >
        <CustomButton
          sx={{ height: "2rem" }}
          variant="contained"
          onClick={async () => {
            const screenMode = location.state.screenMode;
            const disbRecordResponse = await axios.post(
              "/disbursement/getDisbursementData",
              {
                disbHeaderKey: location.state.disbHeaderKey,
                screenMode: screenMode,
              }
            );
            if (disbRecordResponse.status === 200) {
              const dataValue = { ...disbRecordResponse.data };
              if (screenMode === "MODIFY") {
                navigate("/stlap/home/disbursementModify", {
                  replace: true,
                  state: dataValue,
                });
              } else if (screenMode === "CANCEL") {
                navigate("/stlap/home/disbursementCancel", {
                  replace: true,
                  state: dataValue,
                });
              } else if (screenMode === "APPROVE") {
                navigate("/stlap/home/disbursementApprove", {
                  replace: true,
                  state: dataValue,
                });
              } else if (screenMode === "VIEW") {
                navigate("/stlap/home/disbursementView", {
                  replace: true,
                  state: dataValue,
                });
              }
            }
          }}
        >
          Back to Detail
        </CustomButton>
      </Box>{" "} */}
        </>
      )}
    </>
  );
};

export default RepaymentStructure;
